import React from "react";
var __jsx = React.createElement;
import { motion, AnimatePresence } from "framer-motion";
export default function RadioDot(_ref) {
  var selected = _ref.selected;
  return /*#__PURE__*/React.createElement(motion.span, {
    animate: {
      borderColor: selected ? "var(--color-primary-new, #0D0DB5)" : "#e0e0e0",
      backgroundColor: selected ? "var(--color-primary-new, #0D0DB5)" : "#ffffff"
    },
    transition: {
      duration: 0.18
    },
    className: "flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-solid"
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, selected && /*#__PURE__*/React.createElement(motion.span, {
    key: "dot",
    initial: {
      scale: 0
    },
    animate: {
      scale: 1
    },
    exit: {
      scale: 0
    },
    transition: {
      type: "spring",
      stiffness: 500,
      damping: 20
    },
    className: "h-2 w-2 rounded-full bg-white"
  })));
}